import { Navigate } from "react-router";
import { LoginButton } from "./components/auth/LoginButton";
import { useAuth0 } from "@auth0/auth0-react";
import { Container } from "./components/layout/Container";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";

export function Entry() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      loginWithRedirect();
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  if (isLoading) {
    return (
      <Container center>
        <div className="text-2xl font-bold">
          <Loader2 className="w-10 h-10 animate-spin" />
        </div>
      </Container>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <Container center>
      <div className="text-2xl font-bold">
        <Loader2 className="w-10 h-10 animate-spin" />
      </div>
    </Container>
  );
}

export default Entry;
